app.controller('OrderCartController',
    ['$rootScope', '$scope', '$http', '$state',
        function ($rootScope, $scope, $http, $state) {

            $scope.cart_state = "show_cart";
            $scope.form_disabled = true;
            $scope.view_model = {
                checkout_method: "checkout",
                transfer_to_email: "",
                checkout_user: 0,
                checkout_user_email: "",
                transfer_url: 0
            }
            let submitID = null;
            let didReset = false

            const reset = () =>{
                $scope.cart_state = "show_cart";
                $scope.view_model.checkout_method = "checkout";
                $scope.view_model.transfer_to_email = "";
                $scope.view_model.checkout_user = 0;
                $scope.view_model.checkout_user_email = "";
                $scope.view_model.transfer_url = "";
                didReset = true;
            }

            $scope.checkReset = (callback) => {
                if(!didReset){
                    return
                }
                didReset = false;

                if(callback){
                    callback()
                }

            }


            $rootScope.$on('menu_is_cart_visible_change', function () {
                $scope.form_disabled = false;
                submitID = null;
                reset();
            });

            $scope.hideCart = function () {
                $rootScope.service.menu.setCartVisible(false)
            }

            $scope.getCurrentOrder = function () {
                return $rootScope.model.order.current_order;
            }

            $scope.cartQuantity = function () {
                return $rootScope.service.order_helper.cartQuantity($scope.getCurrentOrder());
            }

            $scope.isCartEmpty = function () {
                return $scope.getCurrentOrder().lines.length === 0;
            }

            function handleSubmit(validateFormCallback, successCallback) {

                const activeFormMessageIDs = $scope.activeFormMessageIDs();
                for (let i = 0; i < activeFormMessageIDs.length; i++) {
                    const messageID = activeFormMessageIDs[i];
                    let message = null;
                    switch (messageID) {
                        case "no_customer":
                            message = "You must select a customer.";
                            break;
                        case "cart_is_empty":
                            message = "Your cart is empty, please add something to your cart to checkout.";
                            break;
                        case "no_reference":
                            message = "You must provide a reference for your order.";
                            break;
                        default:
                            break;
                    }
                    if (message) {
                        validateFormCallback(false, $rootScope.site_helper.addErrorMessage(message, null, messageID));
                        return;
                    }
                }

                $scope.form_disabled = true;
                $rootScope.service.order.saveOrder($scope.getCurrentOrder(), function () {
                    $scope.form_disabled = false;
                    if (successCallback) {
                        successCallback();
                    }
                    //Ignore any server errors for the cart. These wil be handled on the checkout screen
                    validateFormCallback(true, []);
                });
            }

            $scope.onEmptyCart = function () {
                $scope.cart_state = "empty_cart";
            };

            $scope.onEmptyCartCancel = function () {
                $scope.cart_state = "show_cart";
            };

            $scope.onEmptyCartConfirm = function () {
                $scope.getCurrentOrder().lines = [];

                $scope.form_disabled = true;
                $rootScope.service.tracking.track_event("Cart", "Emptied");
                $rootScope.service.order.saveOrder($scope.getCurrentOrder(), function (success, data, messages) {
                    $scope.form_disabled = false;
                    $scope.hideCart();
                });
            };

            $scope.onSaveCart = function (validateFormCallback) {

                submitID = "save_cart";
                handleSubmit(validateFormCallback, function () {

                    $rootScope.service.order.startNewOrder();
                    $scope.hideCart();

                });
            };

            $scope.determineUsers = () => {
                const users = $rootScope.model.account.customer_data?._users ?? [];
                if($scope.view_model.checkout_user){
                    let valid = false;
                    for(let user of users){
                        if(parseInt($scope.view_model.checkout_user) === parseInt(user.id)){
                            valid = true;
                            $scope.view_model.checkout_user_email = user.user;
                            break;
                        }
                    }
                    if(!valid){
                        $scope.view_model.checkout_user = 0;
                        $scope.view_model.checkout_user_email = "";
                    }
                }

                $scope.view_model.checkout_user = $scope.view_model.checkout_user ? $scope.view_model.checkout_user : parseInt(users[0]?.id ?? "0");
                return !!$scope.view_model.checkout_user;
            }

            $scope.onCheckout = function (validateFormCallback) {

                submitID = "checkout";
                handleSubmit(validateFormCallback, function () {
                    $scope.hideCart();
                    $rootScope.service.tracking.track_event("Checkout", "Started from cart");
                    $state.go('myba.order-checkout.review');
                });
            }

            $scope.onTransferCart = function (validateFormCallback) {
                const order = $rootScope.model.order.current_order;
                if(!order){
                    return;
                }


                $scope.form_disabled = true;

                const transferURL = $rootScope.model.site.server_url + $state.href("myba.order-transfer-entry", {
                    order_id: order._id,
                })

                const userID = $scope.view_model.checkout_user ? $scope.view_model.checkout_user : parseInt(($rootScope.model.account.customer_data?._users ?? [])[0]?.id ?? "");
                if(!userID){
                    const errors = $rootScope.site_helper.addErrorMessage("User not found");
                    if(!$rootScope.model.account.customer_data?._users){
                        $rootScope.site_helper.addErrorMessage("No Users object for user ID: " +$rootScope.model.account.customer_data?._user_id ?? 0, errors);
                    }
                    validateFormCallback(false, errors);
                    return;
                }

                const transferToEmail = $scope.view_model.transfer_to_email ? $scope.view_model.transfer_to_email : $scope.view_model.checkout_user_email;
                $rootScope.service.staff.transferCart(order, $scope.view_model.checkout_user, transferToEmail, transferURL, function (success, messages) {
                    $scope.form_disabled = false;
                    if (success) {
                        $scope.view_model.checkout_method = "did_transfer";
                        $scope.view_model.transfer_url = transferURL;
                    } else {
                        messages = Array.isArray(messages) ? messages : [messages];
                        $rootScope.site_helper.addErrorMessage("Transfer User ID :" +$scope.view_model.checkout_user, messages)
                    }
                    validateFormCallback(success, messages);
                });
            }

            $scope.getSelectedUser = () => {
                const users = $rootScope.model.account.customer_data?._users ?? [];
                if(!users.length){
                    return {
                        id: 0,
                        user: $rootScope.model.account.customer_data?.email ?? ""
                    }
                }
                for(let user of users){
                    if(parseInt($scope.view_model.checkout_user) === parseInt(user.id)){
                        return user;
                    }
                }
                return null;
            }


            $scope.onManageQuote = function (validateFormCallback) {

                submitID = "manageQuote";
                handleSubmit(validateFormCallback, function () {
                    $scope.hideCart();
                    $state.go('myba.order-quote-manage');
                });
            }

            $scope.activeFormMessageIDs = function () {
                if (submitID) {
                    if ($rootScope.service.staff.isSelectCustomerRequired()) {
                        return ["no_customer"];
                    }
                    if ((submitID === "checkout" || submitID === "manageQuote") && $scope.isCartEmpty()) {
                        return ["cart_is_empty"];
                    }
                    if (!$scope.getCurrentOrder().reference) {
                        return ["no_reference"]
                    }
                }
                return [];
            }

        }]);